import { render } from "./TaskSettingsComments.vue?vue&type=template&id=89d1e336"
import script from "./TaskSettingsComments.vue?vue&type=script&lang=js"
export * from "./TaskSettingsComments.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsComments.vue?vue&type=style&index=0&id=89d1e336&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__